import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { EditArticlesOrderedDetails } from "@coworker/apprestructured/src/task-management/components/EditArticlesOrderedDetails/EditArticlesOrderedDetails";
import { ItemNoAndTypeWithOrderedDetails } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import {
  ORDERED_DETAILS_MODES,
  OrderedDetailsMode,
} from "@coworker/apprestructured/src/task-management/types/OrderedDetailsMode";

function EditArticlesOrderedDetailsDemo() {
  const [disabled, setDisabled] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mode, setMode] = useState<OrderedDetailsMode>(
    ORDERED_DETAILS_MODES.pieces
  );
  const [itemsForAcknowledge, setItemsForAcknowledge] = useState<
    ItemNoAndTypeWithOrderedDetails[]
  >([
    {
      no: "30373588",
      type: "ART",
      pieces: 5,
      pieces_ordered: { quantity: 3, completed: false },
      ptags_ordered: { quantity: 2, completed: false },
    },
    {
      no: "40586508",
      type: "ART",
      pieces: 7,
      pieces_ordered: { quantity: 4, completed: false },
      ptags_ordered: { quantity: 1, completed: false },
    },
  ]);

  return (
    <Demo>
      <Name>EditArticlesOrderedDetails</Name>
      <Highlight>
        <FixaListView id="articles-print-ptag-quantity-demo" size="small">
          <EditArticlesOrderedDetails
            mode={mode}
            disabled={disabled}
            isError={isError}
            itemNosAndTypeWithOrderedDetails={itemsForAcknowledge}
            onCompleteChange={(itemNo, field, completed) => {
              setItemsForAcknowledge((prev) =>
                prev.map((item) =>
                  item.no === itemNo
                    ? { ...item, [field]: { ...item[field], completed } }
                    : item
                )
              );
            }}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="articlesprintptagandquantitydemo-disabled"
          id="articlesprintptagandquantitydemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
        <FixaCheckbox
          label="isError"
          value="articlesprintptagandquantitydemo-iserror"
          id="articlesprintptagandquantitydemo-iserror"
          checked={isError}
          onChange={() => setIsError((prev) => !prev)}
        />
        <FixaCheckbox
          label="Mode: Pieces"
          value="articlesprintptagandquantitydemo-mode-pieces"
          id="articlesprintptagandquantitydemo-mode-pieces"
          checked={mode.id === "pieces"}
          onChange={() => setMode(ORDERED_DETAILS_MODES.pieces)}
        />
        <FixaCheckbox
          label="Mode: PTags"
          value="articlesprintptagandquantitydemo-mode-ptags"
          id="articlesprintptagandquantitydemo-mode-ptags"
          checked={mode.id === "ptags"}
          onChange={() => setMode(ORDERED_DETAILS_MODES.ptags)}
        />
        <FixaCheckbox
          label="Mode: Both"
          value="articlesprintptagandquantitydemo-mode-both"
          id="articlesprintptagandquantitydemo-mode-both"
          checked={mode.id === "both"}
          onChange={() => setMode(ORDERED_DETAILS_MODES.both)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(EditArticlesOrderedDetailsDemo);
